import cn from "classnames";
import React, { Fragment, ReactElement, useEffect, useRef } from "react";
import { useIntersectionObserver } from "src/hooks/use-intersection-observer";

export interface VerticalListProps {
  data: any;
  onEndReached?: () => void;
  onEndReachedThreshold?: number;
  isLoading?: boolean;
  isEmpty?: boolean;
  isLoadingMore?: boolean;
  className?: string;
  scrollOnLastItemOnmount?: boolean;
  LoadingComponent?: ReactElement;
  renderItem: (item: any, index: number) => ReactElement;
  ListEmptyComponent?: ReactElement;
  lastItemRef?: any;
  parentClassName?: string;
}

const VerticalList: React.FC<VerticalListProps> = ({
  data,
  renderItem,
  onEndReachedThreshold = 1,
  ListEmptyComponent,
  onEndReached,
  scrollOnLastItemOnmount = true,
  className = "flex-col-reverse",
  LoadingComponent,
  isLoading,
  isEmpty,
  lastItemRef,
  parentClassName = "",
}) => {
  const div = useRef<HTMLDivElement>(null);
  const view = useIntersectionObserver({
    ref: div,
    options: {
      threshold: onEndReachedThreshold,
      triggerOnce: false,
    },
  });
  let key = 0;

  useEffect(() => {
    if (onEndReached) {
      if (view) onEndReached();
    }
  }, [view]);

  const lastItem = useRef<HTMLDivElement>(null);
  useEffect(() => {
    if (scrollOnLastItemOnmount) {
      lastItem.current?.scrollIntoView();
    }
  }, []);
  return (
    <div className={parentClassName}>
      <div className={cn("flex", className)}>
        {lastItemRef && <div ref={lastItemRef} className="w-full " />}
        {(!data?.length || isEmpty) && !isLoading
          ? ListEmptyComponent
          : data?.map((item: any, index: any) => {
              key++;
              return <Fragment key={key}>{renderItem(item, index)}</Fragment>;
            })}
        {isLoading && LoadingComponent && LoadingComponent}
      </div>
      <div ref={div} className="h-0 w-full"></div>
    </div>
  );
};

export default VerticalList;
